import requestAPI from './requestAPI';
import { toastInfo, toastError, toastSuccess } from '../utils/toastr';

const handlePasteClick = (copyFileData, site_id, directory, setChangedBrowserDataWhenAdd, filesTree) => {
	if (!copyFileData.name) {
		toastInfo('Nothing to paste!', 'Hmmm...');
	} else if (copyFileData.action === 'copy') {
		if (copyFileData.isFolder) {
			const params = {
				routeParams: {
					route: 'copy_dir'
				},
				method: 'POST',
				data: {
					site_id,
					directory: copyFileData.directory ? copyFileData.directory + '/' + copyFileData.name : copyFileData.name,
					new_directory: directory ? directory + '/' + copyFileData.name : copyFileData.name
				}
			};

			const addedFile = {
				value: JSON.stringify({
					name: directory === copyFileData.directory ? copyFileData.name + ' (copy)' : copyFileData.name,
					siteName: copyFileData.siteName,
					siteId: site_id,
					isFolder: true,
					directory: directory ? directory : '/'
				}),
				label: directory === copyFileData.directory ? copyFileData.name + ' (copy)' : copyFileData.name,
				showCheckbox: false,
				children: [ { value: 'waiting server response...', label: 'waiting server response...', showCheckbox: false } ]
			};

			requestAPI(params)
				.then((response) => {
					if (response.data.ms === 'Ошибка' || response.status !== 200) {
						toastError('Something went wrong!', 'Error');
					} else {
						toastSuccess('Folder has been pasted!', 'Done!');
						setChangedBrowserDataWhenAdd(addedFile);
					}
				})
				.catch((err) => {
					toastError(err, 'Error');
				});
		} else {
			const params = {
				routeParams: {
					route: 'copy_file'
				},
				method: 'POST',
				data: {
					site_id,
					directory: copyFileData.directory,
					new_directory: directory,
					filename: copyFileData.name,
					new_filename: copyFileData.name
				}
			};

			const addedFile = {
				value: JSON.stringify({
					name: directory === copyFileData.directory ? '(copy) ' + copyFileData.name : copyFileData.name,
					siteName: copyFileData.siteName,
					siteId: site_id,
					isFolder: false,
					directory: directory ? directory : '/'
				}),
				label: directory === copyFileData.directory ? '(copy) ' + copyFileData.name : copyFileData.name,
				showCheckbox: false
			};

			requestAPI(params)
				.then((response) => {
					if (response.data.ms === 'Ошибка' || response.status !== 200) {
						toastError('Something went wrong!', 'Error');
					} else {
						toastSuccess('File has been pasted!', 'Done!');
						setChangedBrowserDataWhenAdd(addedFile);
					}
				})
				.catch((err) => {
					toastError(err, 'Error');
				});
		}
	} else if (copyFileData.action === 'cut') {
		const path = directory ? directory + '/' : directory;
		const copyCutFileDirectory = copyFileData.directory ? copyFileData.directory + '/' : copyFileData.directory;

		const params = {
			routeParams: {
				route: 'rename'
			},
			method: 'PUT',
			data: {
				site_id,

				name: copyFileData.isFolder
					? copyCutFileDirectory + copyFileData.name + '/'
					: copyCutFileDirectory + copyFileData.name,
				new_name: copyFileData.isFolder ? path + copyFileData.name + '/' : path + copyFileData.name
			}
		};

		const addedFile = copyFileData.isFolder
			? {
					value: JSON.stringify({
						name: copyFileData.name,
						siteName: copyFileData.siteName,
						siteId: site_id,
						isFolder: true,
						directory: directory ? directory : '/'
					}),
					label: copyFileData.name,
					showCheckbox: false,
					children: [
						{ value: 'waiting server response...', label: 'waiting server response...', showCheckbox: false }
					]
				}
			: {
					value: JSON.stringify({
						name: copyFileData.name,
						siteName: copyFileData.siteName,
						siteId: site_id,
						isFolder: false,
						directory: directory ? directory : '/'
					}),
					label: copyFileData.name,
					showCheckbox: false
				};

		requestAPI(params)
			.then((response) => {
				if (response.data.ms === 'Ошибка' || response.status !== 200) {
					toastError('Something went wrong!', 'Error');
				} else {
					toastSuccess('File has been pasted!', 'Done!');
					setChangedBrowserDataWhenAdd(addedFile);
				}
			})
			.catch((err) => {
				toastError('Something went wrong!', 'Error');
			});
	}
};

export default handlePasteClick;
